module.exports = " <div class=\"container container-404\" _v-9b08da12=\"\"> <div class=text-center _v-9b08da12=\"\"> <h1 _v-9b08da12=\"\">404</h1> <h3 _v-9b08da12=\"\">Page not found</h3> <p _v-9b08da12=\"\"> <a class=\"btn btn-lg btn-danger\" v-link=\"{ path: '/' }\" _v-9b08da12=\"\">Back to home</a> </p> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-9b08da12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/404.vue
 ** module id = 51
 ** module chunks = 1
 **/